import EventsSubscribe from './events-subscribe';

export default EventsSubscribe;
